import React from "react";
import LdsBlockListItem from "./LdsBlockListItem";

// Block list props:
// - items: Array of objects with the following properties:
//   - active: Boolean to indicate if the item is active
//   - icon: String with the icon name
//   - title: String with the title
//   - bookmarked: Boolean to indicate if the item is bookmarked
// - the "number" for each item is calculated based on the index of the item in the array

const LdsBlockList = ({ items }) => {
  return (
    <div className="lds-block-list">
      {items?.map((item, index) => {
        return (
          <LdsBlockListItem key={item.title} {...item} number={index + 1} />
        );
      })}
    </div>
  );
};

export default LdsBlockList;
